module.exports = __webpack_public_path__ + "img/pen-dark.da1fb7b.svg";